<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">{{ isParams ? "Mes informations personnelles" : "S'inscrire (1/2)" }}</div>
    </v-ons-toolbar>

    <div class="content">

      <app-error-msg :list="errorMsgList">
        <span v-if="errorMsgList.errorDuplicate">
          - <a href="#" @click="login">Connectez-vous</a> pour accéder à ce compte
          <br />
        </span>
      </app-error-msg>

      <v-ons-list modifier="noborder perflist">

        <app-label input-id="inputPrenom" label="Prénom" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputPrenom" ref="inputPrenom" v-model="subscription.prenom" placeholder="Entrez votre prénom"
                   @keyup-enter="nextInput('inputNom')"></app-input>

        <app-label input-id="inputNom" label="Nom" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputNom" ref="inputNom" v-model="subscription.nom" placeholder="Entrez votre nom"
                   @keyup-enter="nextInput('inputTel')"></app-input>

        <app-label input-id="inputTel" label="Numéro de téléphone portable" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputTel" ref="inputTel" input-type="tel" v-model="subscription.tel" placeholder="Entrez votre 06/07"
                   @keyup-enter="nextInput('inputEmail')"></app-input>

        <app-label input-id="inputEmail" label="Adresse email" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputEmail" ref="inputEmail" input-type="email" v-model="subscription.email" placeholder="Entrez votre email"
                   @keyup-enter="isParams ? save($event) : nextInput('inputCp')"></app-input>

        <template v-if="! isParams">
          <app-label input-id="inputCp" label="Code postal de votre ferme" :error-msg-list="errorMsgList"></app-label>
          <app-input input-id="inputCp" ref="inputCp" input-type="tel" v-model="cp" placeholder="Entrez un code postal"
                     @keyup-enter="closeKeyboard"></app-input>
        </template>

      </v-ons-list>

      <v-ons-list v-if="! isParams" modifier="noborder perflist">

        <v-ons-list-item expandable>
          <div class="left">
            <v-ons-icon icon="lock" class="list-item__icon"></v-ons-icon>
          </div>
          <div class="center">Perfarmer s'engage à protéger vos données</div>

          <div class="expandable-content">
            <v-ons-list modifier="noborder nopadding">
              <v-ons-list-item modifier="nodivider">
                <div class="left">
                  <v-ons-icon icon="chevron-right" class="list-item__icon"></v-ons-icon>
                </div>
                <div class="center">
                  <b>Nous sécurisons vos données</b>
                  conformément à la Réglementation Générale sur la Protection des Données.
                </div>
              </v-ons-list-item>
              <v-ons-list-item modifier="nodivider">
                <div class="left">
                  <v-ons-icon icon="chevron-right" class="list-item__icon"></v-ons-icon>
                </div>
                <div class="center">
                  <b>Nous n'utilisons pas vos données</b>
                  sans votre accord, nous ne les vendons pas à des tiers.
                </div>
              </v-ons-list-item>
              <v-ons-list-item modifier="nodivider">
                <div class="left">
                  <v-ons-icon icon="chevron-right" class="list-item__icon"></v-ons-icon>
                </div>
                <div class="center">
                  <b>Nous sommes transparents</b>
                  avec vous concernant l'utilisation de vos données personnelles.
                </div>
              </v-ons-list-item>
            </v-ons-list>
          </div>
        </v-ons-list-item>

        <v-ons-list-item ref="checkboxCgu">
          <div class="left">
            <v-ons-checkbox modifier="material" :value="true" v-model="checkboxCgu" input-id="checkboxCgu"></v-ons-checkbox>
          </div>
          <label class="center" for="checkboxCgu">
            J'accepte les
            <a href="#" @click="cgu" style="display: contents;">Conditions Générales
              d'Utilisation</a>
            de Perfarmer
          </label>
        </v-ons-list-item>

      </v-ons-list>

      <p v-if="isParams">
        Si vous souhaitez donner accès à votre compte<br />
        <a href="#" @click="showShare">Partager mon compte</a><br />
        <br />
        Si vous souhaitez changer de compte<br />
        <a href="#" @click="logoutConfirm">Se déconnecter</a><br />
        <br />
        Si vous souhaitez effacer les informations de votre compte<br />
        <a href="#" @click="isShow.deleteActionSheet = true">Supprimer mon compte</a>
      </p>
      <footer class="footer--perfbutton">
        <v-ons-button modifier="large--cta perflarge" @click="save">
          {{ isParams ? 'Enregistrer' : 'Valider et ajouter mes OS' }}
          <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
        </v-ons-button>
      </footer>

    </div>

    <v-ons-action-sheet :modifier="$mdModifier" :visible.sync="isShow.deleteActionSheet" cancelable title="Sélectionnez une action">
      <v-ons-action-sheet-button :modifier="$mdModifier" @click="deleteAccount(true)">
        Se déconnecter
      </v-ons-action-sheet-button>
      <v-ons-action-sheet-button :modifier="$mdModifier" @click="deleteAccountConfirm">
        Supprimer mon compte
      </v-ons-action-sheet-button>
      <v-ons-action-sheet-button v-if="! $md" @click="isShow.deleteActionSheet = false">Fermer
      </v-ons-action-sheet-button>
    </v-ons-action-sheet>

    <v-ons-modal :visible="isShow.logoutModal">
      <p style="text-align: center">
        <v-ons-progress-circular :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
      </p>
    </v-ons-modal>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsInscription from '../mixins/inscription.js';

import { store } from '../store.js';

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppLabel from '../partials/Label.vue';
import AppInput from '../partials/Input.vue';

import AppNegoceRequest from './NegoceRequest.vue';
import AppParamsShare from './ParamsShare.vue';
import AppLoginEmail from './LoginEmail.vue';
import AppCgu from './Cgu.vue';

export default {
  mixins: [mixinsCommons, mixinsInscription],
  components: { AppErrorMsg, AppLabel, AppInput },
  props: ['pageStack'],
  data() {
    return {
      subscription: {
        prenom: '',
        nom: '',
        tel: '',
        email: ''
      },
      cp: '',
      checkboxCgu: false,
      cguKey: 0,
      isParams: false,
      isShow: {
        deleteActionSheet: false,
        logoutModal: false,
      },
      state: store.state
    };
  },
  computed: {
    user() {
      return this.state.user;
    }
  },
  methods: {
    login() {
      var email = this.subscription.email;
      this.pageStack.push({
        extends: AppLoginEmail,
        data() {
          return {
            email: email
          }
        }
      });
    },
    async save(event) {
      if (this.isSubmit) {
        return;
      }
      this.closeKeyboard(event);
      this.resetErrorMsgList();

      if (!this.subscription.prenom) {
        this.setErrorMsgList('inputPrenom', "Le prénom est obligatoire");
      }

      if (!this.subscription.nom) {
        this.setErrorMsgList('inputNom', "Le nom est obligatoire");
      }

      if (!this.subscription.tel) {
        this.setErrorMsgList('inputTel', "Le téléphone est obligatoire");
      } else {
        var telRegex = /^(((\+|00)33|0)\s*[6-7]|(\+|00)32\s*4)([\s.-]*\d{2}){4}$/;
        if(this.isParams){
           // on autorise les fixes post-inscription uniquement mode admin via back
          telRegex = /^(((\+|00)33|0)\s*[1-9]|(\+|00)32\s*4)([\s.-]*\d{2}){4}$/;
        }
        if (!telRegex.test(this.subscription.tel)) {
          this.setErrorMsgList('inputTel', "Le numéro de téléphone n'a pas un format valide");
        }
      }

      if (!this.subscription.email) {
        this.setErrorMsgList('inputEmail', "L'email est obligatoire");
      } else {
        var emailRegex = /^([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)@(([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,})$/;
        if (!emailRegex.test(this.subscription.email)) {
          this.setErrorMsgList('inputEmail', "L'email n'a pas un format valide");
        }
      }

      if (!this.isParams) {
        if (!this.cp) {
          this.setErrorMsgList('inputCp', "Le code postal est obligatoire");
        } else {
          var cpRegex = /^\d{4}\d?$/; // cp belge 4 digits
          if (!cpRegex.test(this.cp)) {
            this.setErrorMsgList('inputCp', "Le code postal n'a pas un format valide");
          }
        }
      }

      if (Object.keys(this.errorMsgList).length) {
        this.$scrollTop();
        return;
      }

      if (!this.isParams && !this.checkboxCgu) {
        this.setErrorMsgList('checkboxCgu', "Vous devez accepter les Conditions Générales d'Utilisation");
        this.$scrollTop();

        this.sendTrackEvent('cgu ' + JSON.stringify(this.subscription));
        return;
      }

      this.isSubmit = true;

      const body = {};
      for (const key in this.subscription) {
        body[key] = this.subscription[key];
      }

      if (this.isParams) {

        body.id = this.user.id;
        body.date = this.user.date;

        const fetchInit = this.$getFetchInit();
        fetchInit.body = JSON.stringify(body);
        const callPath = this.$apiDomain + this.getPath('/params/perso');
        try {
          const response = await this.handleRequest(callPath, fetchInit);

          this.updateUserFromResponse(response.user);

          if (response.multi && Object.keys(response.multi).length) {
            this.$emit('set-multi', response.multi);
          }
          this.pageStack.length > 1 && this.pageStack.pop();

        } catch(error) {
            this.handleError(error);
        }
      } else {

        body.cp = this.cp;
        const pushToken = localStorage.getItem('push_token');
        if (pushToken) {
          body.push_token = pushToken; // if bypass step 2
        }
        const fetchInit = this.$getFetchInit();
        fetchInit.body = JSON.stringify(body);
        const callPath = this.$apiDomain + '/inscription/pre';
        try {
          const response = await this.handleRequest(callPath, fetchInit);

          if(response.user){
            this.inscription(response);
          } else {
            body.password = response.password;
            store.data.negoce.request = response.request;
            response.preset = response.preset ? response.preset : [];
            response.suggest = response.suggest ? response.suggest : [];
            this.pageStack.push({
              extends: AppNegoceRequest,
              data() {
                return {
                  subscription: body,
                  checkbox: response.preset,
                  suggest: response.preset.concat(response.suggest)
                }
              }
            });
            this.isSubmit = false;
          }
        } catch(error) {
            if (error.status == 409) {
              this.setErrorMsgList('errorDuplicate', "Un compte Perfarmer existe déjà avec cet email");
              this.handleError(null);
            } else {
              this.handleError(error, "de l'inscription");
            }
        }
      }
    },
    cgu(event) {
      this.pageStack.push(AppCgu);
      event.stopPropagation();
    },
    showShare(){
      this.pageStack.push(AppParamsShare);
    },
    logoutConfirm() {
      this.$ons.notification.confirm({
        modifier: this.$mdModifier,
        title: 'Pas si vite !',
        message: "Assurez-vous de connaître votre mot de passe pour pouvoir vous reconnecter.",
        buttonLabels: ['Annuler', 'Se déconnecter'],
        cancelable: true,
        callback: function (index) {
          if (index === 1) { // -1 if canceled
            this.isShow.logoutModal = true;
            this.logout();
          }
        }.bind(this)
      });
    },
    deleteAccountConfirm() {
      this.isShow.deleteActionSheet = false;
      this.$ons.notification.confirm({
        modifier: this.$mdModifier,
        title: 'Attention !',
        message: "Êtes-vous sûr de vouloir supprimer votre compte Perfarmer ?"
          + " Vous ne pourrez plus accéder aux prix de vos OS."
          + " Pour toute demande spécifique, contactez simplement notre équipe.",
        buttonLabels: ['Annuler', 'Supprimer'],
        cancelable: true,
        callback: function (index) {
          if (index === 1) { // -1 if canceled
            this.deleteAccount();
          }
        }.bind(this)
      });
    },
    async deleteAccount(isLogout) {
      this.isShow.deleteActionSheet = false;
      this.isShow.logoutModal = true;
      if(isLogout){
        this.logout();
      } else {
        const fetchInit = this.$getFetchInit('DELETE', true);
        const callPath = this.$apiDomain + this.getPath('/compte');
        try {
          await this.handleRequest(callPath, fetchInit);
          this.logout();
        } catch(error) {
          this.isShow.logoutModal = false;
          this.handleError(error, 'de la suppression de votre compte', true);
        }
      }
    }
  },
  created() {
    if (this.isParams) {
      this.subscription.prenom = this.user.prenom;
      this.subscription.nom = this.user.nom;
      this.subscription.tel = this.user.tel;
      this.subscription.email = this.user.email;
    }
  }
};
</script>

<style scoped>
ons-checkbox {
  padding: 10px 7px;
}
.list--perflist + p {
  padding-left: 15px;
  margin: 0;
  font-size: 12px;
  line-height: 17px;
}
.list--perflist + p > a {
  font-weight: 400;
  color: black;
}
</style>
